<template>
  <vPopover
    :placement="placement"
    popover-inner-class=""
    :offset="0"
    @show="$emit('show', $event)"
    @hide="$emit('hide', $event)"
  >
    <button
      class="rounded-full p-2 text-gray-600 hover:bg-gray-100 hover:text-brand-yellow-600 focus:shadow-[0_0_0_4px_rgba(238,189,101,0.5)]"
    >
      <AppSvgSymbol name="@escavador/view-grid" />
    </button>
    <template #popover>
      <client-only>
        <ul
          class="top-[56px] z-10 -ml-[5px] mt-2 w-screen overflow-hidden border-gray-300 bg-white 2md:ml-0 2md:mt-0 2md:w-auto 2md:rounded-lg 2md:shadow-md"
        >
          <li v-for="app in apps" :key="app.title" v-close-popover>
            <a
              :href="app.url"
              class="flex cursor-pointer items-center gap-2 p-4 text-sm font-normal leading-5 text-gray-700 hover:bg-gray-200 hover:text-gray-800"
            >
              <AppSvgSymbol :name="app.icon" size="18" />
              <span>
                {{ app.title }}
              </span>
            </a>
          </li>
        </ul>
      </client-only>
    </template>
  </vPopover>
</template>
<script>
import { buildUrl } from "@escavador/url-helper";
import AppSvgSymbol from "../AppSvgSymbol";

const DEFAULT_APPS = [
  {
    title: "Escavador",
    icon: "@escavador/escavador",
    url: buildUrl({ subdomain: "www", path: "/" }, process.env),
  },
  {
    title: "Painel de monitoramento",
    icon: "@escavador/scale",
    url: buildUrl({ subdomain: "app", path: "/" }, process.env),
  },
];

export default {
  name: "AppApps",
  components: {
    AppSvgSymbol,
  },
  props: {
    placement: {
      type: String,
      default: "bottom-start",
    },
    apps: {
      type: Array,
      default: () => DEFAULT_APPS,
    },
  },
  emits: ["show", "hide"],
};
</script>
